import React, { useEffect, useState } from "react";
import { Bell, MessageSquare, Search, Settings, AlertTriangle, User, Plus, ChevronDown, Power } from "react-feather"
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "../Helper/Context/context";
import { logout } from "../Helper/Context/action";
import { FinancialYearHeaderDDL } from "./CommonDDL/FinancialYearHeaderDDL";
import { MonthHeaderDDL } from "./CommonDDL/MonthHeaderDDL";
import moment from "moment";

import Select from 'react-select'


export default function NavbarPlant(props) {
  const optionn = [
    { value: 'Assam', label: 'Assam' },
    { value: 'Manipur', label: 'Manipur' },
    { value: 'Mizoram', label: 'Mizoram' }
  ]


  const [sticky, setSticky] = useState(false)

  const { DashboardHeading, handleGetFinancialYearID, flag, setYearValue, setMonthValue, setMonthLabel, setYearLabel, HYear, YLable, HMonth, MLable, Data, toggle, isopen } = props

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const userDetails = useAuthState();
  const { UserFullName } = userDetails

  const d = new Date();
  let month = d.getMonth();
  var monthMinusOneName = moment().format('MMMM');

  const y = new Date();
  let year = y.getFullYear();
  var YearLables = moment().format('YYYY');
  // console.log("year",year,YearLables)

  const currentYear = new Date().getFullYear();
  // console.log("EmployeeName",EmployeeName)

  const [FinancialYear, setFinancialYear] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",
  })
  const [Month, setMonth] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",

  })
  useEffect(() => {
    if (setYearValue !== undefined || sessionStorage.getItem("yearId")) {
      setYearValue(sessionStorage.getItem("yearId") ? sessionStorage.getItem("yearId") : year)
      setFinancialYear({
        ...FinancialYear,
        ID: sessionStorage.getItem("yearId") ? sessionStorage.getItem("yearId") : year,
        Label: sessionStorage.getItem("yearLable") ? sessionStorage.getItem("yearLable") : YearLables,
      })
    }
    if (setYearLabel !== undefined || sessionStorage.getItem("yearLable")) {
      setYearLabel(FinancialYear.Label)
    }
  }, [FinancialYear.ID])

  useEffect(() => {
    // console.log(Month)
    if (setMonthValue !== undefined || sessionStorage.getItem("monthId")) {
      setMonthValue(sessionStorage.getItem("monthId") ? sessionStorage.getItem("monthId") : month + 1)
      setMonth({
        ...Month,

        ID: sessionStorage.getItem("monthId") ? sessionStorage.getItem("monthId") : month + 1,
        Label: sessionStorage.getItem("monthLable") ? sessionStorage.getItem("monthLable") : monthMinusOneName,
      })

    }
    if (setMonthLabel !== undefined || sessionStorage.getItem("monthLable")) {
      setMonthLabel(Month.Label)

    }
  }, [Month.ID])

  // useEffect(() => {
  //     handleGetFinancialYearID && handleGetFinancialYearID(FinancialYear, Month)
  // }, [FinancialYear.ID, Month.ID])


  const LogOut = () => {
    // console.log("logout")
    logout(dispatch)
    navigate('/')
  }

  const userFullName = sessionStorage.getItem("userFullName")

  const change = () => {
    const scrollValue = document.documentElement.scrollTop
    if (scrollValue > 400) {
      setSticky(true)
    } else {
      setSticky(false)
    }
  }

  window.addEventListener("scroll", change)

  const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' }
  ]

  return (
    <div className="wrapper">
      <nav className="navbar fixed-top d-flex header header2 dark-shadow" style={{
        backgroundColor: '#201f1f', borderRadius:'5px',
        width: isopen ? "" : "calc(100% - 272px)", marginLeft: isopen ? "" : "257px", marginTop: sticky ? "-30px" : ""
      }} >

        <div className="navbar-menu-wrapper d-flex align-items-center justify-content-between" >
          <button onClick={toggle}
            className="navbar-toggler navbar-toggler new_nav align-self-center"
            type="button"
            data-toggle="minimize"
          >
            <span className="icon-menu"></span>
          </button>
          <ul className="navbar-nav mr-lg-2">
            <li className="nav-item  d-none d-lg-block">
              <h5 className="ps-2 pt-2 text-white">Rubber Plantation</h5>
            </li>
          </ul>

          <ul className="navbar-nav navbar-nav-right">
            <div className="d-flex pe-lg-3 me-2 me-lg-0 ">
              <>
                <div className="row mt-0">

                  <div className="col-2" >
                    <Select
                      placeholder="State"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? 'transparent' : 'transparent',
                          borderBottomColor: 'black',
                          boxShadow: 'none',
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          color: 'black'
                        })
                      }}
                      options={optionn} />
                  </div>


                  <div className="col-2" style={{width:'199px'}}>
                  <Select
                      placeholder="Regional Office"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? 'transparent' : 'transparent',
                          borderBottomColor: 'black',
                          boxShadow: 'none',
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          color: 'black'
                        })
                      }}
                      options={optionn} />
                  </div>

                  <div className="col-2" style={{width:'180px'}}>
                  <Select
                      placeholder="Field Station"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? 'transparent' : 'transparent',
                          borderBottomColor: 'black',
                          boxShadow: 'none',
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          color: 'black'
                        })
                      }}
                      options={optionn} />
                  </div>

                  <div className="col-2">
                    <FinancialYearHeaderDDL
                      FinancialYear={FinancialYear}
                      setFinancialYear={setFinancialYear}
                      YLable={YLable}
                      HYear={HYear}
                      flag={flag}
                      setYearValue={setYearValue}
                    />
                  </div>
                  <div className="col-2">
                    <MonthHeaderDDL
                      Month={Month}
                      setMonth={setMonth}
                      MLable={MLable}
                      HMonth={HMonth}
                      FinancialYear={FinancialYear}
                      flag={flag}
                      setMonthValue={setMonthValue}
                    />
                  </div>
                </div>
              </>
            </div>

            <li className="nav-item nav-profile dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                data-toggle="dropdown"
                id="profileDropdown"
              >
                <img src="assets/img/user_img.png" alt="profile" />
                <span className="username" >
                  <h6 className="text-dark">{userFullName}</h6>
                  {/* <p>Super Admin</p> */}
                </span>
                {/* <i
                  className="align-self-center ml-1 text-dark"
                ><ChevronDown /></i> */}
              </a>
              <div
                className="dropdown-menu dropdown-menu-right navbar-dropdown"
                aria-labelledby="profileDropdown"
              >
                <Link className="dropdown-item" onClick={LogOut}>
                  <i className="text-danger mr-2"><Power /></i>
                  Logout
                </Link>
              </div>
            </li>
          </ul>
        </div>





      </nav>
    </div>
  );
}
